import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { ActionsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/actions/actions.component';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from 'src/app/common/services/logger.service';
import { CalendarEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/calendar/calendar.component';
import { LinkCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/link/link.component';
import { RefsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/refs/refs.component';
import { UtilitiesService, OptionsParams } from 'src/app/common/services/utilities.service';
import { TABLE_ACTIONS } from 'src/app/common/ag-grid-table/constants';
import { GamedataDownloadService } from '../../services/gamedata-download.service';


@Component({
  selector: 'app-build-gamedata-v3',
  templateUrl: './build-gamedata-v3.component.html',
  styleUrls: ['./build-gamedata-v3.component.sass']
})
export class BuildGamedataV3Component implements OnInit {
  @ViewChild('agGrid') agGrid: AgGridAngular;
  public entity: string = 'gamedatalogs';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect: string = '';
  public buildParams: any = {};
  public history: any;
  public isLoading: boolean = true;
  public displayModal: boolean = false;
  public development: boolean = false;
  public qa: boolean = false;
  public buildType: boolean = false;
  public localization: boolean = false;
  public english: boolean = false;
  public spanish: boolean = false;
  public french: boolean = false;
  public selectAll: boolean = false;
  public challenges: boolean = false;
  public assets: boolean = false;
  public items: boolean = false;
  public params: any;
  public gamedataDiff: any;
  public showReleaseNotesModal: boolean = false;
  public releaseNotesContent: string = '';
  public releaseNotesLoading: boolean = false;
  public showUpdatedRows: boolean = false;
  public diffTables: { name: string; rows: any[]; isTruncated: boolean }[] = [];
  public expandedTables: Record<string, boolean> = {};
  public objectKeys = Object.keys;
  private options: any = {};
  customQuery: any;

  constructor(
    private agGridToolsService: AgGridToolsService,
    private router: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private dataService: DataService,
    private gamedataDownloadService: GamedataDownloadService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.setOptions();

    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        cellRendererParams: {
          entity: this.entity,
          filterParams: {},
        },
        cellRenderer: LinkCellRendererComponent,
        sortable: true,
        initialSort: 'desc',
        sortIndex: 0,
        initialSortIndex: 0,
        sort: 'desc',
        sortingOrder: ['asc', 'desc'],
        unSortIcon: false,
        filter: 'agNumberColumnFilter',
        filterParams: {
          filterOptions: [
            'equals',
            'notEqual',
            'lessThan',
            'lessThanOrEqual',
            'greaterThan',
            'greaterThanOrEqual',
            'inRange'
          ]
        },
        resizable: true,
        floatingFilter: true,
        suppressSizeToFit: false,
      },
      {
        headerName: 'Gamedata Diff ID',
        field: 'viewDiff',
        cellRenderer: (params: ICellRendererParams) => this.renderGamedataDiffCell(params),
        sortable: false,
        filter: false,
        resizable: true,
        suppressSizeToFit: true,
        width: 150,
        cellStyle: {
          padding: '10px',
          textAlign: 'center'
        }
      },
      {
        headerName: 'Release Notes',
        field: 'releaseNotes',
        cellRenderer: (params: ICellRendererParams) => this.renderReleaseNotesCell(params),
        sortable: false,
        filter: false,
        resizable: true,
        suppressSizeToFit: true,
        width: 140,
        cellStyle: {
          padding: '10px',
          textAlign: 'center'
        }
      },
      {
        headerName: 'Environment',
        field: 'environment',
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['DEV', 'TEST', 'QA', 'LOCALIZATION'],
        },
        floatingFilter: true,
        suppressSizeToFit: true,
        width: 130,
        cellStyle: {
          padding: '10px',
          textAlign: 'center'
        },
        valueFormatter: (params: ValueFormatterParams) => {
          return params.value || 'N/A';
        }
      },
      {
        headerName: 'Triggered At',
        field: 'createdAt',
        sortable: true,
        unSortIcon: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          buttons: ['clear'],
        },
        floatingFilter: true,
        suppressSizeToFit: true,
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          isDate: true,
        },
        valueGetter: this.agGridToolsService.dateValueGetter('createdAt'),
        resizable: true,
        type: 'editableColumn',
        cellEditor: CalendarEditorComponent,
        width: 300,
        autoHeight: true,
        cellStyle: {
          padding: '10px',
          whiteSpace: 'normal',
          lineHeight: '1.5',
        },
        cellClass: 'custom-cell-style',
      },
      {
        headerName: 'Built By',
        field: 'createdBy',
        cellRenderer: RefsCellRendererComponent,
        cellRendererParams: {
          linkFormatter: (params: ICellRendererParams) => {
            return `auth/users?id=${params.value.id}`;
          },
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: this.options.users_ref,
          valueFormatter: (params: ValueFormatterParams) => {
            return `${params.value.name} (${params.value.id})`;
          },
          keyCreator: (params: ValueFormatterParams) => {
            return params.value._id;
          },
          comparator: this.agGridToolsService.nameASC,
          isSingleRefFilter: true,
          populate: true,
          select: '_id id name'
        },
        floatingFilter: true,
        autoHeight: true,
      },
      {
        headerName: 'Time Taken',
        field: 'timeTaken',
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueFormatter: (params: ValueFormatterParams) => {
          const timeTaken = params.value;
          if (timeTaken !== null && timeTaken !== undefined) {
            const minutes = Math.floor(timeTaken);
            const seconds = Math.round((timeTaken - minutes) * 60);
            return `${minutes}m ${seconds}s`;
          }
          return '';
        },
      },
      {
        headerName: 'Build Time',
        field: 'buildTime',
        sortable: true,
        unSortIcon: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          buttons: ['clear'],
        },
        floatingFilter: true,
        suppressSizeToFit: true,
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          isDate: true,
        },
        valueGetter: this.agGridToolsService.dateValueGetter('createdAt'),
        resizable: true,
        type: 'editableColumn',
        cellEditor: CalendarEditorComponent,
        width: 300,
        autoHeight: true,
        cellStyle: {
          padding: '10px',
          whiteSpace: 'normal',
          lineHeight: '1.5',
        },
        cellClass: 'custom-cell-style',
      },
      {
        headerName: 'Download Gamedata SQLite',
        field: 'downloadSQLite',
        cellRenderer: (params: ICellRendererParams) => this.renderDownloadSQLiteCell(params),
        sortable: false,
        filter: false,
        resizable: true,
        width: 120,
        cellStyle: {
          textAlign: 'center'
        }
      }
    ]

    this.bulkUpdateColDefs = [];

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);

    this.agGridToolsService.disableTableActions([
      TABLE_ACTIONS.ACTIONS,
      TABLE_ACTIONS.NEW,
      TABLE_ACTIONS.TABLE_SEARCH,
      TABLE_ACTIONS.COLUMNS_PRESETS,
      TABLE_ACTIONS.SAVED_FILTERS,
      TABLE_ACTIONS.GRID_VIEW_SETTINGS,
      TABLE_ACTIONS.ROW_SELECTED,
      TABLE_ACTIONS.FULL_EDIT_MODE,
    ]);

    this.router.queryParams.subscribe(params => {
      if (params.id) {
        this.params = params.id;
        this.customQuery = {  "id": params.id  };
      }
    });
  }

  /**
   * Download SQLite file from a specific row
   */
  async downloadSQLiteFromRow(rowData: any): Promise<void> {
    console.log('🔄 Downloading SQLite from row:', rowData);
    
    // Get build version and environment from row data
    const buildVersion = this.getBuildVersionFromRow(rowData);
    const environment = this.getEnvironmentFromRow(rowData);
    
    // Use the download service to handle the entire download flow
    await this.gamedataDownloadService.downloadWithPrompt(buildVersion, environment);
  }

  /**
   * Extracts build version from row data
   * Priority: devGamedata.buildVersion → testGamedata.buildVersion → qaGamedata.buildVersion
   */
  private getBuildVersionFromRow(rowData: any): string | null {
    if (!rowData) {
      return null;
    }
    
    return rowData.devGamedata?.buildVersion || 
           rowData.testGamedata?.buildVersion || 
           rowData.qaGamedata?.buildVersion || 
           null;
  }

  /**
   * Extracts environment from row data based on which gamedata has a buildVersion
   * Returns 'dev', 'test', or 'stage' accordingly
   */
  private getEnvironmentFromRow(rowData: any): string {
    if (!rowData) {
      return 'dev'; // default
    }
    
    if (rowData.devGamedata?.buildVersion) {
      return 'dev';
    } else if (rowData.testGamedata?.buildVersion) {
      return 'test';
    } else if (rowData.qaGamedata?.buildVersion) {
      return 'stage';
    }
    
    return 'dev'; // default fallback
  }

  /**
   * Renders the Gamedata Diff ID cell with a clickable link or "No Diff" text
   */
  private renderGamedataDiffCell(params: ICellRendererParams): HTMLElement {
    // Use gamedataDiffId field directly from row data (enriched by backend)
    const diffId = params.data?.gamedataDiffId;

    if (diffId) {
      const link = document.createElement('a');
      // XSS Prevention: Sanitize diffId before using in href
      const safeDiffId = encodeURIComponent(String(diffId));
      link.href = `/gamedata-diff-v2?id=${safeDiffId}`;
      link.textContent = String(diffId);
      link.className = 'gamedata-diff-link';
      link.title = `View GameData Diff ${diffId}`;
      link.style.color = 'var(--primary-color)';
      link.style.textDecoration = 'none';
      link.style.fontWeight = '600';
      link.style.cursor = 'pointer';
      
      link.onmouseenter = () => {
        link.style.textDecoration = 'underline';
      };

      link.onmouseleave = () => {
        link.style.textDecoration = 'none';
      };

      return link;
    } else {
      const span = document.createElement('span');
      span.textContent = 'No Diff';
      span.className = 'gamedata-diff-no-data'; // CSS handles all styling
      return span;
    }
  }

  /**
   * Renders the Download SQLite cell with a clickable link or "No File" text
   */
  private renderDownloadSQLiteCell(params: ICellRendererParams): HTMLElement {
    const rowData = params.data;
    const buildVersion = rowData?.devGamedata?.buildVersion;

    if (buildVersion) {
      const span = document.createElement('span');
      span.textContent = 'Download';
      span.className = 'sqlite-download-link';
      span.title = 'Download SQLite database file';
      span.style.color = 'var(--primary-color)';
      span.style.cursor = 'pointer';
      span.style.fontWeight = '600';

      span.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.downloadSQLiteFromRow(rowData);
      };

      span.onmouseenter = () => {
        span.style.textDecoration = 'underline';
      };

      span.onmouseleave = () => {
        span.style.textDecoration = 'none';
      };

      return span;
    }

    const span = document.createElement('span');
    span.textContent = 'No File';
    span.className = 'sqlite-no-data';
    return span;
  }

  private renderReleaseNotesCell(params: ICellRendererParams): HTMLElement {
    const diffId = params.data?.gamedataDiffId;

    if (!diffId) {
      const span = document.createElement('span');
      span.textContent = 'No Notes';
      span.className = 'sqlite-no-data';
      return span;
    }

    const span = document.createElement('span');
    span.textContent = 'View Notes';
    span.style.color = 'var(--primary-color)';
    span.style.cursor = 'pointer';
    span.style.fontWeight = '600';
    span.onmouseenter = () => { span.style.textDecoration = 'underline'; };
    span.onmouseleave = () => { span.style.textDecoration = 'none'; };
    span.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openReleaseNotes(diffId);
    };
    return span;
  }

  async openReleaseNotes(diffId: number): Promise<void> {
    this.releaseNotesContent = '';
    this.diffTables = [];
    this.expandedTables = {};
    this.showUpdatedRows = false;
    this.showReleaseNotesModal = true;
    this.releaseNotesLoading = true;

    try {
      const results = await this.dataService.getDocumentAsync('GamedataDiff', { query: { id: diffId }, limit: 1 });
      const doc = Array.isArray(results) ? results[0] : results;
      this.releaseNotesContent = doc?.diff?.completedResume || 'No release notes available for this build.';

      const tables = doc?.diff?.tables || {};
      this.diffTables = Object.entries(tables)
        .filter(([, t]: [string, any]) => t.updated_rows?.length > 0)
        .map(([name, t]: [string, any]) => ({
          name,
          rows: t.updated_rows,
          isTruncated: t.is_truncated ?? false,
        }));
    } catch {
      this.releaseNotesContent = 'Failed to load release notes.';
    } finally {
      this.releaseNotesLoading = false;
    }
  }

  toggleTable(name: string): void {
    this.expandedTables[name] = !this.expandedTables[name];
  }

  async onDataUpdated(): Promise<void> {
    this.isLoading = true;

    try {
      // The grid's server-side datasource re-fetches its own (paginated) page,
      // so there's no need to separately pull every gamedataLogs record here.
      if (this.agGrid && this.agGrid.api) {
        setTimeout(() => {
          this.agGrid.api.refreshServerSide({ purge: true });  // Force server-side data reload
        }, 0);
      }
    } catch (error) {
      console.error('Error updating data:', error);
    } finally {
      this.isLoading = false;
    }
  }

  showModal() {
    this.displayModal = true;
  }

  setBuildType(type: boolean) {
    this.buildType = type;
  }

  async setOptions() {
    const entities = [
      { ref: 'users_ref', entity: 'users', select: 'name id _id', query: { } },
    ];

    // Using the new approach
    for (const { ref, entity, select, query } of entities) {
      const params = new OptionsParams({
        entity, select, query
      });
      await this.utilitiesService.getOptionsFromRef(this.options, ref, entity, false);
    }

  }
}

